import * as DateFilter from './dateFilter'
import * as TimeStampFilter from './timeStampFilter'
import * as TimeStampFNowFilter from './timeStampFromNowFilter'
import * as cpfCnpjFilter from './cpfCnpjFilter'
import * as foneFilter from './foneFilter'

export default {
  DateFilter,
  TimeStampFilter,
  TimeStampFNowFilter,
  cpfCnpjFilter,
  foneFilter
}



// WEBPACK FOOTER //
// ./src/filters/index.js